// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3PpPt","left":"InfoRow_left__1H4Pl"};